export const prependUrlWithHttps = (url: string) => {
  if (!url) {
    throw new Error("URL is required");
  }

  if (typeof url !== "string") {
    throw new Error("URL must be a string");
  }

  const trimmedUrl = url.trim();
  if (!trimmedUrl) {
    throw new Error("Trimmed URL must not be empty");
  }

  return trimmedUrl.startsWith("http") ? trimmedUrl : `https://${trimmedUrl}`;
};
